/**
 * LogoTextForm: editor form for the `logo-text` block.
 *
 * data: { imageUrl, imageAlt, heading, body, buttonText?, buttonLink?, reversed? }
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

export default function LogoTextForm({ data, onChange }) {
    const d = data || {};

    const update = (field, value) => onChange({ ...d, [field]: value });

    return (
        <>
            <Form.Group className="mb-3" controlId="logo-text-imageUrl">
                <Form.Label>Image URL</Form.Label>
                <Form.Control
                    type="text"
                    value={d.imageUrl || ''}
                    placeholder="https://..."
                    onChange={(e) => update('imageUrl', e.target.value)}
                />
            </Form.Group>
            <Form.Group className="mb-3" controlId="logo-text-imageAlt">
                <Form.Label>Image Alt Text</Form.Label>
                <Form.Control
                    type="text"
                    value={d.imageAlt || ''}
                    onChange={(e) => update('imageAlt', e.target.value)}
                />
            </Form.Group>
            <Form.Group className="mb-3" controlId="logo-text-heading">
                <Form.Label>Heading</Form.Label>
                <Form.Control
                    type="text"
                    value={d.heading || ''}
                    onChange={(e) => update('heading', e.target.value)}
                />
            </Form.Group>
            <Form.Group className="mb-3" controlId="logo-text-body">
                <Form.Label>Body</Form.Label>
                <Form.Control
                    as="textarea"
                    rows={4}
                    value={d.body || ''}
                    onChange={(e) => update('body', e.target.value)}
                />
            </Form.Group>
            <Form.Group className="mb-3" controlId="logo-text-buttonText">
                <Form.Label>Button Text (optional)</Form.Label>
                <Form.Control
                    type="text"
                    value={d.buttonText || ''}
                    onChange={(e) => update('buttonText', e.target.value)}
                />
            </Form.Group>
            <Form.Group className="mb-3" controlId="logo-text-buttonLink">
                <Form.Label>Button Link (optional)</Form.Label>
                <Form.Control
                    type="text"
                    value={d.buttonLink || ''}
                    placeholder="/about or https://..."
                    onChange={(e) => update('buttonLink', e.target.value)}
                />
            </Form.Group>
            <Form.Text muted>
                The button only renders when both Button Text and Button Link
                are set.
            </Form.Text>
            <Form.Check
                type="checkbox"
                id="logo-text-reversed"
                className="mt-3"
                checked={Boolean(d.reversed)}
                onChange={(e) => update('reversed', e.target.checked)}
                label="Flip layout (image on right)"
            />
        </>
    );
}

LogoTextForm.propTypes = {
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
};
